export type pricingModelType = 'visitsCount' | 'pageCount' | undefined;
export enum PricingModel {
  visitCount = 'visitsCount',
  pageCount = 'pageCount',
}
export interface PlanType {
  id: string;
  name: string;
  displayName: string;
  for: string;
  limitation: number;
  selfPurchase: boolean;
  price: number;
  monthlyPrice: number;

  tier: number;
  popular: boolean;
  visitsLimitation: number;
  pricingModelPlan: pricingModelType;
  hidden: boolean;
}

export interface LicenseDetails {
  id: string;
  domain: string;
  status: string;
  active: boolean;
  customPrice: number;
  monthly: boolean;
  pageCount: number;
  licenseType: string;
  shouldCancelNextCycle: boolean;
  cancellationFlagValue: boolean;
  timeLeft: number | string;
  datePlanExpires?: string;
  plan: {
    tier: number;
    id?: string;
    name: string | null;
    pricingModelPlan: pricingModelType;
    limitation: number;
    visitsLimitation: number;
  };
  pricingModel: pricingModelType;
  pluginInstallSource: string;
  finalDiscount?: number;
  discountEnabled?: boolean;
  autoRenew: boolean;
  giveGrace: boolean;
}
